<template>
  <section class="about">
    <div class="about_left">
      <!-- 标题 -->
      <div class="home_title">
        <div class="left">
          <h1><i>A</i>BOUT</h1>
          <p>{{ about.top_title }}</p>
        </div>
      </div>
      <p class="dh_text4">
        {{ about.top_des?.replace(/<[^>]+>/g, "") }}
      </p>
      <router-link class="more iconfont icon-jiantou b" :to="{ path: '/about' }">MORE</router-link>
    </div>
    <div class="right">
      <video v-if="about?.top_thumb?.endsWith('mp4')" :src="$baseURL + about?.top_thumb" autoplay muted></video>
      <img v-else :src="$baseURL + about?.top_thumb" :alt="about.top_title" />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    about: {
      type: Object,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.about {
  display: flex;
  margin-left: var(--containerLeft);

  .about_left {
    width: 37%;
    padding-right: 95px;
    background-image: url(../../assets/image/home_about_bg.svg);
    background-size: 100% auto;
    background-position-y: bottom;
    background-repeat: no-repeat;

    &>p {
      color: #999;
      line-height: 2;
      margin: 30px 0 80px;
    }
  }

  .right {
    flex: 1;

    video,
    img {
      width: 100%;
    }
  }
}

@media (max-width: 1100px) {
  .about {
    .about_left {
      padding-right: 50px;

      &>p {
        margin: 10px auto 30px;
      }
    }
  }
}

@media (max-width: 900px) {
  .about {
    display: block;
    margin-right: var(--containerLeft);

    .about_left {
      width: 100%;
      background: none;
      margin-bottom: 20px;

      &>p {
        margin: 10px auto;
      }
    }
  }
}
</style>